import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BaseGenericInputComponent } from '../base-generic-input/base-generic-input.component';

@Component({
    selector: 'mat-generic-date-input',
    templateUrl: './generic-date-input.component.html',
    styleUrls: [ '../base-generic-input/base-generic-input.component.scss', './generic-date-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: GenericDateInputComponent,
        },
    ],
})
export class GenericDateInputComponent extends BaseGenericInputComponent<string> {

    constructor(
        @Optional()
        @Self()
        protected myNgControl: NgControl,
        protected myChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(myChangeDetectorRef);

        if (this.myNgControl) {
            this.myNgControl.valueAccessor = this;
        }
    }

}
